import { render } from "./SettingsNon.vue?vue&type=template&id=4afbd4b0&scoped=true&ts=true"
import script from "./SettingsNon.vue?vue&type=script&lang=ts"
export * from "./SettingsNon.vue?vue&type=script&lang=ts"

import "./SettingsNon.vue?vue&type=style&index=0&id=4afbd4b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afbd4b0"]])

export default __exports__